var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloudShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_66496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80273 11.499L8.26758 14.165H4.25098C3.89355 14.165 3.5625 13.9717 3.38379 13.6611L0.131836 7.99805C-0.0439453 7.69043 -0.0439453 7.3125 0.131836 7.00195L1.36816 4.8457L2.89453 7.5L5.19434 11.499H9.80273Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8682 7.99805L11.6162 13.6641C11.4375 13.9746 11.1064 14.168 10.749 14.168H8.26758L9.80273 11.502L12.1025 7.5L9.7998 3.50098H12.8555L14.8652 7.00195C15.0439 7.30957 15.0439 7.69043 14.8682 7.99805Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 3.50098H5.19727L2.89453 7.5L1.36816 4.8457L3.38086 1.33594C3.55957 1.02539 3.89062 0.832031 4.24805 0.832031H10.752C11.1094 0.832031 11.4404 1.02539 11.6191 1.33594L12.8584 3.50098Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80273 3.50098L12.1025 7.5L9.79981 11.499H5.19727L2.89453 7.5L5.19727 3.50098H9.80273Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.49902C8.60449 5.49902 9.50098 6.39551 9.50098 7.5C9.50098 8.60449 8.60449 9.50098 7.5 9.50098C6.39551 9.50098 5.49902 8.60449 5.49902 7.5C5.49902 6.39551 6.39551 5.49902 7.5 5.49902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.752 0.832031C11.1094 0.832031 11.4404 1.02539 11.6191 1.33594L12.8115 3.41602L12.8584 3.49805L11.6162 1.33301C11.4404 1.02539 11.1094 0.832031 10.752 0.832031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.752 0.832031H4.25098C3.89355 0.832031 3.5625 1.02539 3.38379 1.33594L1.36816 4.8457L1.3916 4.88672L3.38086 1.41797C3.55957 1.10742 3.89063 0.914063 4.24805 0.914063H10.752C11.1094 0.914063 11.4404 1.10742 11.6191 1.41797L12.7646 3.41602H12.8115L11.6191 1.33594C11.4404 1.02539 11.1094 0.832031 10.752 0.832031Z",
    fill: "#689DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 3.41602H5.19727L2.89453 7.41504V7.5L5.19727 3.50098H9.80273V3.49805H12.8115L12.7646 3.41602Z",
    fill: "#3A71DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 3.41602L12.8584 3.49805L12.8115 3.41602Z",
    fill: "#D1D3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 3.41602H12.7646L12.8115 3.49805H12.8584L12.8115 3.41602Z",
    fill: "#5885DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36816 4.8457L0.131836 7.00195C0.117188 7.02832 0.102539 7.05762 0.0908203 7.08398C0.102539 7.05469 0.117188 7.02832 0.131836 7.00195L1.36816 4.8457L2.89453 7.5L5.19434 11.499H9.7998H5.19727L2.89453 7.5L1.3916 4.88965L1.36816 4.8457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36816 4.84863L0.131836 7.00195C0.117188 7.02832 0.102539 7.05762 0.0908203 7.08398C0.0351563 7.2041 0.00585938 7.33301 0.00292969 7.46777C0.00292969 7.46484 0.00292969 7.46191 0.00292969 7.45898C0.00292969 7.47363 0.00292969 7.48828 0.00585938 7.5C0.0175781 7.35352 0.0615234 7.21289 0.134766 7.08691L1.37109 4.93066L2.89746 7.58496L5.19727 11.584H9.75293L9.7998 11.502H5.19727L2.89453 7.5L1.36816 4.84863Z",
    fill: "#FCC937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36816 4.8457L1.3916 4.88672L1.36816 4.8457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.131836 7.99805L3.38086 13.6641C3.55957 13.9746 3.89063 14.168 4.24805 14.168H8.26465H4.25098C3.89355 14.168 3.5625 13.9746 3.38379 13.6641L0.131836 7.99805Z",
    fill: "#F2D7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 7.46777C-0.00292969 7.63477 0.0322266 7.80176 0.108398 7.95117C0.117187 7.96582 0.123047 7.98047 0.131836 7.99512L3.38086 13.6611C3.55957 13.9717 3.89062 14.165 4.24805 14.165H8.26465L8.31152 14.0801H4.25098C3.89355 14.0801 3.5625 13.8896 3.38379 13.5762L0.131836 7.91309C0.0585937 7.78711 0.0146484 7.64355 0.00292969 7.5C0.00292969 7.51465 0 7.5293 0 7.54102C0 7.51758 0 7.49121 0.00292969 7.46777Z",
    fill: "#EFA106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31445 14.083L8.26758 14.165V14.168L8.29688 14.1152L8.31445 14.083Z",
    fill: "#E1402D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 7.45898C0.00292969 7.46191 0.00292969 7.46484 0.00292969 7.46777C0.00292969 7.49121 0.00292969 7.51758 0.00292969 7.54102C0.00292969 7.52637 0.00292969 7.51172 0.00601961 7.5C0.00292969 7.48535 0.00292969 7.4707 0.00292969 7.45898Z",
    fill: "#F0AC2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80273 3.50098L12.1025 7.5H12.1494L9.89648 3.58301H9.84961L9.80273 3.50098Z",
    fill: "#C83D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30566 14.1006L8.29688 14.1152L8.29102 14.124L8.30566 14.1006ZM14.9941 7.5C14.9824 7.64648 14.9385 7.78711 14.8652 7.91309L11.6162 13.582C11.4375 13.8926 11.1064 14.0859 10.749 14.0859H8.36133L8.31445 14.168H8.26758H10.749C11.1064 14.168 11.4375 13.9746 11.6162 13.6641L14.8682 7.99805C14.9531 7.85156 14.9971 7.68457 15 7.51465C15 7.52344 15 7.53223 15 7.54102C14.9971 7.52637 14.9971 7.51465 14.9941 7.5Z",
    fill: "#C83D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29688 14.1152L8.26758 14.168V14.165L8.29102 14.124L8.29688 14.1152Z",
    fill: "#C03B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 3.50098L14.8652 7.00195C14.9062 7.07227 14.9355 7.14551 14.959 7.21875C14.9385 7.14258 14.9062 7.06934 14.8652 6.99902L12.8584 3.50098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1494 7.5H12.1025L9.7998 11.499L8.30566 14.0977L8.31445 14.083H8.36133L9.7998 11.5811L12.1494 7.5ZM12.8584 3.50098H9.84961L9.89648 3.58301H12.8584L14.8682 7.08691C14.9414 7.21289 14.9854 7.35645 14.9971 7.5C14.9971 7.48535 15 7.4707 15 7.45898C15 7.47656 15 7.49707 15 7.51465C15.0029 7.41504 14.9883 7.31543 14.9619 7.22168C14.9385 7.14551 14.9092 7.07227 14.8682 7.00488L12.8584 3.50098Z",
    fill: "#EE695D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 3.49805H9.80273V3.50098H9.84961H12.8115V3.49805Z",
    fill: "#618DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 3.49805H12.8115V3.50098H12.8584V3.49805Z",
    fill: "#799DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84961 3.50098H9.80273L9.84961 3.58301H9.89648L9.84961 3.50098Z",
    fill: "#D3645A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36426 14.083H8.31738L8.30859 14.0977L8.29395 14.124L8.27051 14.165H8.31738L8.36426 14.083ZM14.9971 7.45898C14.9971 7.47363 14.9971 7.48828 14.9941 7.5C14.9941 7.51465 14.9971 7.5293 14.9971 7.54102C14.9971 7.53223 14.9971 7.52344 14.9971 7.51465C15 7.49414 14.9971 7.47656 14.9971 7.45898Z",
    fill: "#D3645A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29102 14.124L8.26758 14.165L8.29102 14.124Z",
    fill: "#CD6255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_66496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudShort);
export default __webpack_public_path__ + "static/media/GoogleCloud-Short.7c2c0e025efef04e03ab4cf6ebe7c57b.svg";
export { ForwardRef as ReactComponent };